import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { Checkbox, createFilterOptions } from '@mui/material'
import { Autocomplete } from '../form'
import { default as TextFieldMui } from '@mui/material/TextField'
import { useWatch } from 'react-hook-form'

export const CountriesAutoComplete = ({ name, control, countryData }) => {
  const countries = useWatch({ name, control })

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />

  const countryFilterOptions = createFilterOptions({
    ignoreCase: true,
    stringify: (option: any) => option.code + option.name,
  })

  return (
    <Autocomplete
      name={name}
      control={control}
      multiple
      options={countryData}
      limitTags={3}
      disableCloseOnSelect
      filterOptions={countryFilterOptions}
      isOptionEqualToValue={(option, value) => option.code === value.code}
      getOptionLabel={option => option.code}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option?.name} ({option?.code})
        </li>
      )}
      renderInput={params => (
        <TextFieldMui
          {...params}
          placeholder={countries && countries.length === 0 ? 'Select Ship To Country' : ''}
        />
      )}
    />
  )
}
